import { useState, useEffect } from "react";
import { create_judge0_coding_user_action } from "../../../redux/_actions/common/test.actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
function useMentorQuestions(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [resultData, setResultData] = useState(null);

  const onBlurInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    formData[name] = value;
  };
  const createQuestion = async () => {
    const data = await dispatch(create_judge0_coding_user_action(formData));
    if (data && data.data) {
      setResultData(data && data.data);
    }
  };
  const navigateAnswerQuestion = () => {
    const id = resultData?.id;
    navigate(`/answer-question/${id}`, {
      state: {
        id: id,
      },
    });
  };
  return {
    onBlurInput,
    resultData,

    createQuestion,
    navigateAnswerQuestion,
  };
}
export default useMentorQuestions;
